import { modifyLinkBehavior } from '../utils.js';

export default function headerButton() {
  const widgetName = 'headerButtonWidget';
  const widgetOpts = headerButtonWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: true,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const card = $(`#${widgetName} .card-widget-item`);
      const URL = data.items[0]?.URL !== null;
      if (hasData && URL) {
        card.prepend('<div id="gloss"><div>');
        modifyLinkBehavior(data, card);
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
